import { UpdateInputAutocompleteAction, AutocompleteType, UPDATE_INPUT_AUTOCOMPLETE } from "./setInputAutocompleteText"

export interface InputAutocompleteState {
    results: any[]
    type?: AutocompleteType
}

export type InputAutocompleteAction = UpdateInputAutocompleteAction

export const initialInputAutoCompleteState: InputAutocompleteState = {
    results: []
}

export const inputAutocompleteReducer = (state: InputAutocompleteState = initialInputAutoCompleteState, action: InputAutocompleteAction) => {
    switch (action.type) {
        case UPDATE_INPUT_AUTOCOMPLETE: {
            const newState: InputAutocompleteState = {
                type: action.autocompleteType,
                results: action.items
            }
            return newState
        }
        default:
            return state
    }
}